import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { map, delay } from "rxjs/operators";
import { CookieService } from "ngx-cookie-service";
import { environment } from "../../../../../environments/environment";
import { ParkingType, ParkingTypeDto } from "../../../models/parking/parking-type.model";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { MapperParkingTypeService } from "../../../mappers/parking/mapper-parking-type.service";

@Injectable({
    providedIn: 'root',
})
export class ApiParkingTypeService {
    private baseUrl = environment.apiPrivateUrl;

    constructor(
        private cookieService: CookieService,
        private apiMethodService: ApiMethodService,
        private mapper: MapperParkingTypeService
    ) {}

    getParkingTypes(): Observable<ParkingType[]> {
        const token = this.cookieService.get('token');
        return this.apiMethodService.request<ParkingTypeDto[]>(
            '/backoffice/GetParkingType', 
            'GET',
            this.baseUrl,
            {
                isConsoleLog: true,
                labelLog: 'GetParkingType',
                token: token,
                headerOnly: false,
            },
        ).pipe(
            map(dtos => (dtos || []).map(dto => this.mapper.mapParkingTypeFromDto(dto)))
        );
    }

    createParkingType(payload: ParkingType): Observable<any> {
        const token = this.cookieService.get('token');
        const dto = this.mapper.mapParkingTypeToDto(payload);
        return this.apiMethodService.request<any>(
            '/backoffice/CreateParkingType',
            'POST',
            this.baseUrl,
            {
                isConsoleLog: true,
                labelLog: 'CreateParkingType',
                token: token,
                headerOnly: false,
                body: dto
            },
        );
    }
}
